<template>
  <div>
    <Loader v-if="loading" cover/>
    <div class="vx-row">
      <!-- LEFT SIDE -->
      <div class="vx-col w-full lg:w-3/5 sm:w-full sm:order-2 lg:order-1">
          <!-- SUBJECT INFO-->
          <subject-overview v-if="studentEnrollDetail"
                            :student-enroll-detail="studentEnrollDetail">
          </subject-overview>

          <!-- SUBJECT INTRODUCTION-->
          <subject-introduction v-if="studentEnrollDetail"
                                :student-enroll-detail="studentEnrollDetail">
          </subject-introduction>

          <!-- COURSE OUTLINE UNIT-->
          <course-outline-unit-info :course-outline-units="courseOutlineUnits"
                                    :studentEnrollDetail="studentEnrollDetail">
          </course-outline-unit-info>
      </div>

      <!-- RIGHT SIDE -->
      <div class="vx-col w-full lg:w-2/5 sm:w-full sm:order-1 lg:order-2">
        <!-- TEACHER PROFILE-->
        <teacher-profile :teacher="teacher"></teacher-profile>

        <!-- ASSESSMENT-->
        <assessment-info :course-outline-assessments="courseOutlineAssessments"
                         :student-enroll-detail-id="studentEnrollDetailId"></assessment-info>

        <!-- CLASS ASSIGNMENT-->
        <class-assignment v-if="classSection && student && studentEnrollDetailId"
                          :class-assignments="classAssignments"
                          :student-enroll-detail-id="studentEnrollDetailId"
                          :class-section="classSection"
                          :student="student">
        </class-assignment>

        <!-- CLASS MATERIAL-->
        <class-material :class-materials="classMaterials"></class-material>

      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import SubjectOverview from "./Components/SubjectOverview";
import SubjectIntroduction from "./Components/SubjectIntroduction";
import StudentEnrollDetail from "@/store/modules/student-enroll/student-enroll-detail";
import TeacherProfile from "@/views/pages/E-Learning/ClassOverview/Components/TeacherProfile";
import AssessmentInfo from "@/views/pages/E-Learning/ClassOverview/Components/AssessmentInfo";
import ClassMaterial from "@/views/pages/E-Learning/ClassOverview/Components/ClassMaterial";
import ClassAssignment from "@/views/pages/E-Learning/ClassOverview/Components/ClassAssignment";
import CourseOutlineUnitInfo from "@/views/pages/E-Learning/ClassOverview/Components/CourseOutlineUnitInfo";
import {createNamespacedHelpers} from "vuex";

if (!store.state.StudentEnrollDetail) store.state.registerModule(`StudentEnrollDetail`, StudentEnrollDetail);

const {
  mapActions: mapStudentEnrollDetailActions,
} = createNamespacedHelpers(`StudentEnrollDetail`);


export default {
  components: {
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
    SubjectOverview,
    SubjectIntroduction,
    TeacherProfile,
    AssessmentInfo,
    ClassMaterial,
    ClassAssignment,
    CourseOutlineUnitInfo,
  },
  data() {
    return {
      loading: true,
      studentEnrollDetailId: null,
      studentEnrollDetail: null,
    }
  },
  computed: {
    courseOutlineAssessments() {
      let courseOutlineAssessments = [];
      if (this.studentEnrollDetail) {
        courseOutlineAssessments = this.studentEnrollDetail
          .courseOutlineRegistration
          .courseOutline
          .courseOutlineAssessments;
      }
      return courseOutlineAssessments;
    },
    classMaterials() {
      let courseOutlineAssessments = [];
      if (this.studentEnrollDetail) {
        courseOutlineAssessments = this.studentEnrollDetail
          .classSection
          .classMaterials;
      }
      return courseOutlineAssessments;
    },
    classAssignments() {
      let classAssignments = [];
      if (this.studentEnrollDetail) {
        classAssignments = this.studentEnrollDetail
          .classSection
          .classAssignments
          .filter(e => {
            return e.active
          })
          .map(item => {
          return {
            ...item,
            showEditForm: false,
          }
        });
      }
      return classAssignments;
    },
    classSection() {
      let classSection = null;
      if (this.studentEnrollDetail) {
        classSection = this.studentEnrollDetail.classSection;
      }
      return classSection;
    },
    student() {
      let student = null;
      if (this.studentEnrollDetail) {
        student = this.studentEnrollDetail.student;
      }
      return student;
    },
    teacher() {
      if (this.studentEnrollDetail) {
        return this.studentEnrollDetail.courseOutlineRegistration.teacher;
      }
      return {};
    },
    courseOutlineUnits(){
      let courseOutlineUnits = null;
      if (this.studentEnrollDetail) {
        courseOutlineUnits = this.studentEnrollDetail
          .courseOutlineRegistration
          .courseOutline
          .courseOutlineUnits;
        let studentUnitTests = this.studentEnrollDetail.studentUnitTests;
        let studentUnitLearns = this.studentEnrollDetail.studentUnitLearns;
        let vdoSetUnits = [];
        if(this.studentEnrollDetail.classSection.vdoSet){
          vdoSetUnits = this.studentEnrollDetail.classSection.vdoSet.vdoSetUnits;
        }

        courseOutlineUnits = courseOutlineUnits.map((item) => {
          let studentUnitTest = studentUnitTests.find(element =>
            element.courseOutlineUnit && element.courseOutlineUnit.id === item.id);
          let vdoSetUnit = vdoSetUnits.find(element =>
            element.courseOutlineUnit && element.courseOutlineUnit.id === item.id && element.status === 'enable'
          );
          let studentUnitLearn = studentUnitLearns.find(element =>
            element.courseOutlineUnit &&
            element.courseOutlineUnit.id === item.id &&
            vdoSetUnit && vdoSetUnit.id === element.vdoSetUnit.id);

          return {
            ...item,
            studentUnitTest,
            studentUnitLearn,
            vdoSetUnit,
          }
        });
      }
      return courseOutlineUnits;
    },
  },
  methods: {
    ...mapStudentEnrollDetailActions({
      getStudentEnrollDetailById: 'getStudentEnrollDetailById',
    }),
    async loadData() {
      this.loading = true;
      if(this.$route.params.studentEnrollDetailId){
        this.studentEnrollDetailId = this.$route.params.studentEnrollDetailId;
        this.studentEnrollDetail = await this.getStudentEnrollDetailById({id: this.studentEnrollDetailId});
      }
      this.loading = false;
    },
  },
  async beforeMount() {
    await this.loadData();
  }
}
</script>

<style lang="scss">

</style>
